module.exports = __webpack_public_path__ + "img/genet_precoce.8119506c.jpg";